import React from "react";
import { Resource } from "../../../modules/academy/models";
import { ResourceCard } from "./ResourceCard";

export interface ResourceListProps {
  resources?: Resource[];
}

export function ResourceList({ resources }: ResourceListProps) {
  if (!resources || resources.length === 0) {
    return (
      <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700">
        <h2 className="text-lg font-semibold mb-2">Ressources</h2>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Aucune ressource definie pour ce theme pour l'instant.
        </p>
      </section>
    );
  }

  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">Ressources</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {resources.map((res) => (
          <ResourceCard key={res.id} {...res} />
        ))}
      </div>
    </section>
  );
}
